/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { gettHeaderByType, settHeaderByType } from '@/api/common'
import {
    getCustomerConversionList,
    setCustomerConversionUser,
    setCustomerConversion,
    setCustomerConversionBack,
    customerConversionExportData,
    setCustomerConversionBackByCustomerConversionId,
    getMarketClueSourceList,
    setCustomerConversionFollowByIdList,
    checkCustomerConversionFollow, setCustomerConversionPublic, setCustomerConversionResale
} from '@/api/customer'
import { TableHeader, TableRow } from './interface'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import realTimeSokcet from '@/utils/socket.io'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import CommonData from "@/utils/commonData";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class ConversionTransfrom extends Vue {
    [x: string]: any
    socket: any = null
    tableHeadPopoverShow = false
    tableData: TableRow[] = []
    tableHeader: TableHeader[] = []
    checkTableRow: any = []
    tableHeadFilter = {
        marketClueSource: '',
        conversionName: '',
        marketClueName: '',
        weChat: '',
        marketClueDirectorUserIdList: [],
        directorUserIdList: [],
        leaderUserIdList: [],
        createdUserIdList: [], //客户接收人 2022-11-18
        status: '',
        isSign: '',
        level: '',
        intentionalityList: [],
        followAt: '',
        createdAt: '',
        eduTemandList: [],
        gradeList: [],
        attendSchool: '',
        specialized: '',
        targetSpecialized: '',
        followNum: '',
        lastFollowAt: null,
        level2Scourse:[], // 二级来源
        isFromPublic:'' ,// 是否从公海捞出
        level2DepartmentId :'' ,// 客户接收人二级部门
        region:'' ,// 所在城市
        selectNameList:'' , // 卡点原因
        directorLevel2DepartmentId:'' , // 负责人所属二级部门
        eduCode:'', // 客户编号
        signAt:'' ,// 客户编号
        remark:'' ,// 备注
        dredgeAt:'' ,// 捞取时间
        country:'' ,// 留学地区
        isFromPractice:'' ,// 实习/就业产品引流：
        marketClueSourceType : '' , // 线索来源
        marketCooperationSource :'',
        productRequirement :'',
        phone :'',
    }
    followNumScopen = '' // 跟进次数范围
    followNumVal = '' // 跟进次数
    page = 1
    limit = 20
    total = 0
    selfTotal = 0
    // tableRandom = Math.random()
    receiverUser = ''
    editReceiverUserDialog = false
    sendBackDialog = false
    sendBackSelect = ''
    sendBackCause = ''
    sendBackOptions = [
        { value: '0', name: '退群' },
        { value: '1', name: '至少联系三次未联系上' },
        { value: '2', name: '非咨询科研项目' },
        { value: '3', name: '其他' }
    ]
    gradeOptions = CommonData.gradeList
    eduTemandOptions = [ '留学', '高考', '考研', '保研', '考博', '无升学需求', '待定' ,'就业', '国内求职','海外求职']
    intentionalityList =  [
        {label:'A',value:'A',interpretation:'（7天内签约）'},
        {label:'B',value:'B',interpretation:'（15天内签约）'},
        {label:'C',value:'C',interpretation:'（30天内签约）'},
        {label:'D',value:'D',interpretation:'（90天内签约）'},
        {label:'E',value:'E',interpretation:'（长期跟进）'},
        {label:'F',value:'F',interpretation:'（流失并调入公海）'},
        {label:'已签约',value:'已签约',interpretation:''},
    ]
    intentionalityName: any = {}
    loading = false
    sendBackClueID: number; // 退户线索id
    menuBtn = menuBtn
    cancelTabkBackClueDialog = false
    cancelTabkBackClueId: number
    sendBackDialogConfirmButtonDisabled = false
    exportBUttonDisabled = false
    exportHeaderDialogVisible = false
    /*新增*/
    ClueSourceList: any = []
    source = ''
    sourcePage = 1
    sourceLimit = 20

    deadline: Date = null // 截止时间
    startDate: Date = null
    endDate: Date = null // 计算得出最后的结束时间为什么时候
    followDialog = false
    // timePickerOptions = { start: '00:00', step: '01:00', end: "23:59" }
    datePickerOptions = {
        disabledDate: (v: Date) => (true),
    }
    time = ''
    selectValue = ''
    textValue = ''
    flag = false // 是否修改过时间没如果修改过就给后台传值

    idList: any = [] //批量跟进id
    marketClueSourceList = []
    tableKey = Math.random()
    timer = null
    vdaH = 0 //屏幕高度
    originHeight: any = '' //屏幕高度
    heightScroll = false
    popHeight = 0
    draggableList = []
    draggableListChange = []
    dialogShow = false // 调入公海弹框显隐
    transformId = ''

    level2DepartmentList = [
        {name: '北京咨询部', id: 1047},
        {name: '上海咨询部', id: 1048},
        {name: '深圳咨询部', id: 1049},
        {name: '成都咨询部', id: 1065},
        {name: '广州咨询部', id: 1143},
        {name: '苏州咨询部', id: 1146}
    ]
    selectNameList =[]
    reasonList = [
        '升学意向', '支付能力', '时间安排', '家庭支持', '替代品类', '竞品干扰', '产品功能', '差评干扰', '产品匹配', '无故失联','学员意愿','专业选择','其他'
    ]
    dialogResaleShow = false
    resaleId = null
    sourceList = [
        {name: '合作伙伴', val: 0},
        {name: '线上市场', val: 1},
        {name: '其它', val: 2},
        {name: '高校', val: 3},
        {name: '分管', val: 4},
    ]
    marketCooperationSourceList = [
        {label: 'BD自开拓', value: '0'},
        {label: '市场自开拓', value: '1'},
        {label: 'KA战略合作', value: '2'},
        {label: '高校业务部门', value: '3'},
        {label: '咨询平台', value: '4'},
        {label: '咨询自渠道', value: '5'}
    ]
    isHaveRegisterInfo = ''
    isHaveProject = ''
    isSolveSelect = ''
    isDisabled = false

    // computed
    get userId() {
        return UserModule.userId
    }

    get arrfollowNumScopen(){
        const followNumScopen = this.followNumScopen
        const followNumVal = this.followNumVal
        return {
            followNumScopen , followNumVal
        }
    }

    // created
    created() {
        this.getTableHeader()
        this.getMarketClueSourceList()
        const h = document.documentElement.clientHeight || document.body.clientHeight;
        this.vdaH = h - 260 ;
        this.popHeight = this.vdaH
    }
    mounted() {
        this.datePickerOptions.disabledDate = (v: Date) => {
            // const emun = { '高': 1, '中': 3, '低': 7, }
            const emun = {'A': 3, 'B': 5, 'C': 7, 'D': 15, 'E': 30}
            const nowtime = v.getTime()
            const starttime = new Date().setHours(0,0,0,0)+1
            const endtime = (new Date().getTime() + 1000 * 60 * 60 * 24 * emun[this.selectValue])
            this.startDate = new Date()

            if(!this.selectValue) {
                return true
            }
            if(this.selectValue === '已签约' || this.selectValue === 'F' ) {
                return !(v.setHours(0,0,0,0) >= starttime)
            }
            this.endDate = new Date(endtime)
            return !(nowtime >= starttime && nowtime <= endtime)
        }
    }

    beforeUpdate() {
        // this.$nextTick(() => {
        //     let h = document.documentElement.clientHeight || document.body.clientHeight;
        //     this.vdaH = h - 260 + 'px' + '!important';
        //     this.originHeight = document.getElementById("idu").offsetHeight;
        //     console.log('h', h)
        //     console.log('this.vdaH', this.vdaH)
        //     console.log(' this.originHeight ', this.originHeight)
        //     if (this.originHeight >(h - 260)) { //盒子超出屏幕高度
        //         this.heightScroll = true
        //     } else {
        //         this.heightScroll = false
        //     }
        //     this.popHeight= this.heightScroll ? this.vdaH : this.originHeight
        //     console.log('this.popHeight',this.popHeight)
        // })
    }
    // methods

    // 转销
    clickResale(row: any){
        this.resaleId = row.id
        this.dialogResaleShow  = true
    }

    dialogResaleCancel() {
        this.dialogResaleShow = false
    }

    async dialogResaleConfirm() {
        await setCustomerConversionResale({id: this.resaleId})
        this.getTableData()
        this.$message.success('转销成功')
        this.dialogResaleShow = false
    }


    async getTableHeader() {
        this.loading = true
        const data: any = await gettHeaderByType(3)
        this.draggableList = data.headerUserList
        this.tableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.loading = false
        this.getTableData()
    }
    // 批量跟进购买意向
    intentionalityChange(val: string) {
        // const arr = ['已签约', '已拒绝', '暂无', '已退群/拉黑']
        // if(!arr.includes(this.selectValue)) {
        if (val === 'A') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 3));
        this.endDate = this.deadline
        if (val === 'B') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 5));
        this.endDate = this.deadline
        if (val === 'C') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 7));
        this.endDate = this.deadline
        if (val === 'D') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 15));
        this.endDate = this.deadline
        if (val === 'E') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 30));
        this.endDate = this.deadline
        if (val === 'F') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24 * 30));
        this.endDate = this.deadline
        if (val === '已签约') this.deadline = new Date(new Date().getTime() + (1000 * 60 * 60 * 24));
        this.endDate = this.deadline
        // this.$nextTick(() => {
        //     this.time = this.endDate.getHours() + ':' + '00'
        // })
        this.deadlineChange()
        // } else {
        //     this.deadline = null
        //     this.time = ''
        // }
    }
    deadlineChange() {
        // this.time = ''
        // if(new Date(this.deadline).setHours(0,0,0,0) === new Date(this.startDate).setHours(0,0,0,0)) {
        //     this.timePickerOptions.start = `${this.startDate.getHours()}:${this.startDate.getMinutes()}`
        //     this.timePickerOptions.end = '23:59'
        // } else if(new Date(this.deadline).setHours(0,0,0,0) === new Date(this.endDate).setHours(0,0,0,0)) {
        //     this.timePickerOptions.start = '00:00'
        //     this.timePickerOptions.end = `${this.endDate.getHours()}:${'00'}`
        //     // this.timePickerOptions.end = `${this.endDate.getHours()}:${this.endDate.getMinutes()}`
        // } else {
        //     this.timePickerOptions.start = '00:00'
        //     this.timePickerOptions.end = '23:59'
        // }
    }
    // 批量跟进确认
    async handleConfirmfollow() {
        if (this.selectValue === '' || this.textValue === '') {
            this.$message.error(`请将${this.selectValue === '' ? '购买意向，' : ''}${this.textValue === '' ? '跟进内容，' : ''}填写完整`)
            return
        }
        if(!(this.selectValue =='A'||this.selectValue=='已签约') && this.selectNameList.length==0){
            this.$message.error(`请将卡点原因填写完整`)
            return
        }
        const obj = {
            idList: this.idList,
            intentionality: this.selectValue,
            content: this.textValue,
            // lastFollowAt: formatDate('yyyy-MM-dd', new Date(this.deadline)) + ' ' + (this.time ? this.time : '00:00'),
            lastFollowAt: formatDate('yyyy-MM-dd', new Date(this.deadline)),
            selectNameList: this.selectNameList,
            isHaveRegisterInfo: this.isHaveRegisterInfo,
            isHaveProject: this.isHaveProject,
            isSolveSelect: this.isSolveSelect,
        }
        if(!this.deadline) {
            delete obj.lastFollowAt
        }
        await setCustomerConversionFollowByIdList(obj)
        this.$message.success('批量跟进成功')
        this.page = 1
        this.getTableData()
        this.selectNameList = []
        this.selectValue = ''
        this.textValue = ''
        this.deadline = null
        // this.time = ''
        this.isHaveRegisterInfo = ''
        this.isHaveProject = ''
        this.isSolveSelect = ''
        this.flag = false
        this.followDialog = false
    }

    get isHaveRegisterInfoAndIsHaveProjectAndIsSolveSelect() {
        const {isHaveRegisterInfo, isHaveProject, isSolveSelect} = this
        return {
            isHaveRegisterInfo,
            isHaveProject,
            isSolveSelect
        }
    }

    @Watch('isHaveRegisterInfoAndIsHaveProjectAndIsSolveSelect', {
        immediate: true,
        deep: true
    })
    handleVal(newVal, oldVal) {
        //     如果都是"是"
        if (newVal.isHaveRegisterInfo === '是' && newVal.isHaveProject === '是' && newVal.isSolveSelect === '是') {
            this.selectValue = 'A'
            this.isDisabled = true
        } else {
            this.selectValue = ''
            this.isDisabled = false
            //     禁止选中A
            this.intentionalityList.forEach((item: any) => {
                if (item.value === 'A') {
                    item.disabled = true
                } else {
                    item.disabled = false
                }
            })
        }
    }
    async getTableData() {
        this.loading = true

        this.intentionalityName = this.tableHeadFilter.intentionalityList.map(item => {
            return item
        })
        // 跟进次数
        this.tableHeadFilter.followNum = this.followNumScopen + this.followNumVal
        const obj = this.removePropertyOfNull({
            ...this.tableHeadFilter,
            page: this.page,
            limit: this.limit
        })
        if ('createdAt' in obj) {
            (function () {
                obj.createdAt = obj.createdAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.createdAt = obj.createdAt.join('&')
            })()
        }
        if ('followAt' in obj) {
            (function () {
                obj.followAt = obj.followAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.followAt = obj.followAt.join('&')
            })()
        }
        // 签约时间
        if ('signAt' in obj) {
            (function () {
                obj.signAt = obj.signAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.signAt = obj.signAt.join('&')
            })()
        }
        // 捞取时间

        if ('dredgeAt' in obj) {
            (function () {
                obj.dredgeAt = obj.dredgeAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.dredgeAt = obj.dredgeAt.join('&')
            })()
        }
        if(obj.lastFollowAt) obj.lastFollowAt = formatDate('yyyy-MM-dd', new Date(obj.lastFollowAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(obj.lastFollowAt[1]))
        const data: any = await getCustomerConversionList(obj)
        this.tableData = data.customerConversionList
        this.total = data.allNum
        this.tableKey = Math.random()

        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
        this.loading = false

    }

    handleSelectionChange(arr: any) {
        this.checkTableRow = arr
        const idArr = []
        this.checkTableRow.map(item => {
            idArr.push(item.id)
        })
        this.idList = idArr
    }
    openDtatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerStatisticsData')
    }
    /*
    * 统计报表*/
    openStatisticsTable() {
        window.open(window.location.origin + this.$route.matched[0].path + '/transformCustomerCollectionReport')
    }
    async exportExcel(keys: string = '') {
        this.exportBUttonDisabled = true
        const obj = this.removePropertyOfNull({ ...this.tableHeadFilter, page: this.page, limit: this.limit, keys })
        if ('createdAt' in obj) {
            (function () {
                obj.createdAt = obj.createdAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.createdAt = obj.createdAt.join('&')
            })()
        }
        if ('followAt' in obj) {
            (function () {
                obj.followAt = obj.followAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.followAt = obj.followAt.join('&')
            })()
        }
        if ('signAt' in obj) {
            (function () {
                obj.signAt = obj.signAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.signAt = obj.signAt.join('&')
            })()
        }

        // 捞取时间
        if ('dredgeAt' in obj) {
            (function () {
                obj.dredgeAt = obj.dredgeAt.map((item: string) => {
                    return formatDate('yyyy-MM-dd', new Date(item))
                });
                obj.dredgeAt = obj.dredgeAt.join('&')
            })()
        }
        if(obj.lastFollowAt) obj.lastFollowAt = formatDate('yyyy-MM-dd', new Date(obj.lastFollowAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(obj.lastFollowAt[1]))
        customerConversionExportData(obj).then(() => {
            this.exportBUttonDisabled = false
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).catch(() => {
            this.exportBUttonDisabled = false
        })
    }

    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 3})
            this.$message.success('设置成功')
            this.tableHeadPopoverShow = false
            this.getTableHeader()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }
    doCancel(){
        this.draggableListChange = JSON.parse(JSON.stringify( this.draggableList))
        this.tableHeadPopoverShow = false

    }
    async confirmEditReceiverUser() {
        if (!this.receiverUser) {
            this.$message.error('负责人不可为空！')
            return
        }
        const idArray: number[] = this.checkTableRow.map((item: any) => (item.id))
        await setCustomerConversionUser({
            userId: this.receiverUser,
            customerConversionIdList: idArray
        })
        this.$message.success('修改负责人成功')
        this.editReceiverUserDialog = false
        this.getTableData()
    }

    // 确认回退线索
    async confirmSendBack() {
        if (!this.sendBackSelect) {
            this.$message.error('请将回退原因填写完整')
            return
        }
        this.sendBackDialogConfirmButtonDisabled = true
        setCustomerConversionBack({
            customerConversionId: this.sendBackClueID,
            types: this.sendBackSelect,
            content: this.sendBackCause
        }).then(() => {
            this.$message.success('线索已经进入回退审批')
            this.sendBackDialog = false
            this.getTableData()
            setTimeout(() => {
                this.sendBackDialogConfirmButtonDisabled = false
            }, 3000)
        }).catch(() => {
            this.sendBackDialogConfirmButtonDisabled = false
        })

    }
    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }
    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }

    // 查看
    clickView(row: any) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerEdit?id=' + row.id + '&isEdit=0')
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

    // 编辑
    clickEdit(row: any) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerEdit?id=' + row.id + '&isEdit=1')
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }
    async receiveMarketClue(id: number) {
        await setCustomerConversion(id)
        this.$message.success('成功接收线索')
        this.getTableData()
    }


    initSocket() {
        const time = setInterval(() => {
            if(Vue.prototype.$socket.on) {
                realTimeSokcet(this.userId, 'MarketClue', this.getTableData)
                clearInterval(time)
            }
        }, 100)
    }


    clickFollow(row: any) {
        // 校验转化客户是否可以跟进
        checkCustomerConversionFollow({id: row.id}).then((res: any) => {
            const win = window.open(`${window.location.origin + this.$route.matched[0].path}/transfromCustomerFollow?id=${row.id}&name=${row.realName ? row.realName : row.marketClueName}&haveFinanceContract=${res.haveFinanceContract}`, '_blank')
            const time = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(time)
                }
            }, 500)
        }).catch(error => {
            // this.$message.error(error)
            console.log(error)
        })
    }
    clickFollowRecord(row: any) {
        window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerFollowRecord?id=' + row.id, '_blank')
    }
    clickCancelBack(row) {
        this.cancelTabkBackClueId = row.id
        this.cancelTabkBackClueDialog = true
    }
    moveToPublic(row) {
        this.transformId = row.id
        this.dialogShow = true
    }
    async confirmCancelTakeBackClue() {
        await setCustomerConversionBackByCustomerConversionId(this.cancelTabkBackClueId)
        this.$message.success('撤销回退线索成功')
        this.getTableData()
        this.cancelTabkBackClueDialog = false
    }

    // 退回线索
    sendBackclue(id: number) {
        this.sendBackClueID = id
        this.sendBackDialog = true
    }
    removePropertyOfNull(object: any) {
        const obj = JSON.parse(JSON.stringify(object))
        Object.keys(obj).forEach(item => {
            if ((obj[item] === '' || !obj[item] || obj[item].length === 0) && obj[item] !== 0) {
                delete obj[item]
            }
        })
        return obj;
    }

    // 防抖节流函数
    timeout = null
    debounce() {
        return (() => {
            if (this.timeout) clearTimeout(this.timeout) // 如果持续触发，那么就清除定时器，定时器的回调就不会执行。
            this.timeout = setTimeout(() => {
                this.confirmSendBack()
            }, 500)
        })()
    }

    txtClassFun(row ) {
        let cla = ''
        if(row.followStatus === '2'){ //已超时
            cla = 'red-txt'
        }else if(row.followStatus === '1'){ //即将超时
            cla = 'orange-txt'
        }
        // const time = new Date().getTime()
        // let cla = ''
        // const date = new Date(row.followAt).getTime()
        // if(row.followIntentionality === '高') {
        //     const nextDate = 1000 * 60 * 60 * 24 + date
        //     if(nextDate - time <= 1000 * 60 * 60 * 24 ) cla = 'red-txt'
        // } else if(row.followIntentionality === '中') {
        //     const nextDate = 1000 * 60 * 60 * 24 * 3 +  date
        //     if(nextDate - time <= 1000 * 60 * 60 * 24 * 2 && nextDate - time > 1000 * 60 * 60 * 24) cla = 'orange-txt'
        //     if(nextDate - time <= 1000 * 60 * 60 * 24) cla = 'red-txt'
        // } else if(row.followIntentionality === '低') {
        //     const nextDate = 1000 * 60 * 60 * 24 * 7 +  date
        //     if(nextDate - time <= 1000 * 60 * 60 * 24 * 2 && nextDate - time > 1000 * 60 * 60 * 24) cla = 'orange-txt'
        //     if(nextDate - time <= 1000 * 60 * 60 * 24) cla = 'red-txt'
        // }
        return cla
    }


    @Watch('editReceiverUserDialog')
    handleWatchEditReceiverUserDialog(val: boolean) {
        if (val === false) {
            this.receiverUser = ''
        }
    }
    @Watch('sendBackDialog')
    handleWatchSendBackDialog(val: boolean) {
        if (val === false) {
            this.sendBackSelect = ''
            this.sendBackCause = ''
        }
    }
    @Watch('userId')
    handleWatchUserId() {
        this.initSocket()
    }


//    新增的
    async getMarketClueSourceList() {
        const data: any = await getMarketClueSourceList(
            {
                page: this.sourcePage,
                limit: this.sourceLimit,
                source: this.source
            }
        )
        this.ClueSourceList = data.marketClueSourceList
    }

    async handleClueSource() {
        if ((this.ClueSourceList.length == 0 || !this.source) && !this.tableHeadFilter.marketClueSource) {
            this.source = null
            this.sourcePage = 1
            // this.sourceLimit = 20
            const result: any = await getMarketClueSourceList(
                {
                    page: this.sourcePage,
                    limit: this.sourceLimit,
                    source: this.source
                }
            )
            this.ClueSourceList = result.marketClueSourceList
        }

    }

    handleClueSourceBlur(e) {
        this.source = null
        this.sourcePage = null
        this.sourceLimit = null
        this.getMarketClueSourceList()
    }

    async remoteMethod(query: any) {
        this.source = query
        this.sourcePage = 1
        this.sourceLimit = 20
        if (query !== '') {
            const result: any = await getMarketClueSourceList({
                page: this.sourcePage,
                limit: this.sourceLimit,
                source: query
            })
            this.ClueSourceList = result.marketClueSourceList
        } else {
              this.ClueSourceList = []
              this.getMarketClueSourceList()
        }
    }

    loadmore() {
        this.sourcePage = 1
        this.sourceLimit += 20
        this.getMarketClueSourceList();
    }

    clearClueSource() {
        this.tableHeadFilter.marketClueSource = ''
        this.source = null
        this.sourcePage = 1
        this.sourceLimit = 20
        this.getMarketClueSourceList()
    }

    changeClueSource(val) {
        // this.tableHeadFilter.marketClueSource = val
        this.marketClueSourceList = val
        this.page = 1
        this.getTableData()
    }

    //-    调入公海
    dialogCancle(){
        this.dialogShow = false
    }

    async dialogConfirm() {
        await setCustomerConversionPublic({
            id: this.transformId
        })
        this.$message.success('调入公海成功！')
        this.getTableData()
        this.dialogShow = false
    }

    changeTable() {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }



    changeReceiverUsers(e) {
        this.receiverUser = e.id
    }

    changemarketClueDirectorUsers(e) {
        this.tableHeadFilter.marketClueDirectorUserIdList = e.id
        this.page = 1
        this.getTableData()
    }

    changeleaderUsers(e) {
        this.tableHeadFilter.leaderUserIdList = e.id
        this.page = 1
        this.getTableData()
    }

    changecreatedUsers(e) {
        this.tableHeadFilter.createdUserIdList = e.id
        this.page = 1
        this.getTableData()
    }

    changedirectorUsers(e) {
        this.tableHeadFilter.directorUserIdList = e.id
        this.page = 1
        this.getTableData()
    }

    @Watch('arrfollowNumScopen')
    handlearrfollowNumScopen(nVal, oVal) {
        if ((nVal.followNumScopen && nVal.followNumVal)||(!nVal.followNumScopen && !nVal.followNumVal)) {
            this.pageChange(1)
        }
    }
}
